import * as Yup from "yup";

export const emailValidation = (t) =>
    Yup.object({
        email: Yup.string()
            .email(t("forgot_password.incorrectEmail"))
            .max(255)
            .required(t("login.required")),
    });

export const passwordValidation = (t) =>
    Yup.object({
        password: Yup.string()
            .min(8, t("registration.passwordLength"))
            .max(255)
            .required(t("registration.required")),
        rePassword: Yup.string()
            .oneOf([Yup.ref("password"), null], t("registration.notMatch"))
            .required(t("registration.required")),
    });
